import { SteemActionType } from '@popup/steem/actions/action-type.enum';
export const setSwitchToRpc = (rpc) => {
    return {
        type: SteemActionType.SET_SWITCH_TO_RPC,
        payload: rpc,
    };
};
export const setDisplayChangeRpcPopup = (display) => {
    return {
        type: SteemActionType.SET_DISPLAY_SWITCH_RPC,
        payload: display,
    };
};
